import colors from './colors';
import breakpoints, { breakpointsNumber } from './breakpoints';
import text from './text';

// used for menu & container (likely used for calculation)
const headerHeightMobile = 3.5; // rem
const headerHeightDesktop = 6; // rem
const verticalGutter = 2; // rem
const gutter = 40; // px
const sideMenuWidth = 280; // px

const boxShadow = {
  small: `0 1px ${gutter / 4}px rgba(0,0,0,0.1)`,
  medium: `0 1px ${gutter / 4}px ${gutter / 8}px rgba(0,0,0,0.1)`,
  menu: `${verticalGutter / 4}rem 0 ${verticalGutter / 4}rem rgba(0,0,0,0.1)`,
  footer: '0 -0.5rem 1rem rgba(0, 0, 0, 0.04)'
};

const borderRadius = {
  small: '3px',
  medium: '4px',
  large: '8px'
};

export {
  colors,
  breakpoints,
  breakpointsNumber,
  text,
  headerHeightDesktop,
  headerHeightMobile,
  verticalGutter,
  gutter,
  sideMenuWidth,
  boxShadow,
  borderRadius
};
